import { validateEmail } from "../../../../utils/validation";

function validate(values) {
  let errors = {};
  if (!values.email_address || !validateEmail(values.email_address)) {
    errors.email_address = "Please enter a valid email address.";
  }
  if (!values.reason_to_be_chim) {
    errors.reason_to_be_chim = "Please enter a good reason to be a Chimney.";
  }
  if (!values.top_ten) {
    errors.top_ten = "Please enter some of your favorite albums, tracks and artists.";
  }
  if (!values.location) {
    errors.location = "Please enter your location or closest major city.";
  }
  if (!values.chim_name || values.chim_name.length < 3) {
    errors.chim_name = "Please enter a valid Chimney name.";
  }
  if (!values.real_name) {
    errors.real_name = "Please enter your name.";
  }
  if (!values.current_totd) {
    errors.current_totd = "Please enter your current favorite song title and artist.";
  }

  return errors;
}

export { validate };
